module.exports = __webpack_public_path__ + "img/bnbchain.4c563e5e.png";